export const cssTopValues = {
  0: ["10%", "25%", "40%", "55%", "70%"],
  1: ["5%", "43.75%", "52.5%", "61.25%", "70%"],
  2: ["3.75%", "13.75%", "52.5%", "61.25%", "70%"],
  3: ["3.75%", "12.5%", "22.5%", "61.25%", "70%"],
  4: ["3.75%", "12.5%", "21.25%", "31.25%", "70%"],
  5: ["10%", "25%", "40%", "55%", "70%"],
};

export const cssHeightValues = {
  0: ["30%", "30%", "30%", "30%", "30%"],
  1: ["60%", "30%", "30%", "30%", "30%"],
  2: ["30%", "60%", "30%", "30%", "30%"],
  3: ["30%", "30%", "60%", "30%", "30%"],
  4: ["30%", "30%", "30%", "60%", "30%"],
  5: ["30%", "30%", "30%", "30%", "30%"],
};
